import { ApolloError, gql } from 'apollo-boost';
import { externalLogin } from 'core/api/auth';
import { showSnackbar } from 'core/components/snackbar';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import { getErrors } from 'core/utils/apollo';
import React from 'react';
import { useHasAnyFutureCoursesQuery, useSyncWithCalendarOrderMutation } from 'site/graphql';
import CalendarIcon from '../../../svg/calendar.svg';

gql`
    query HasAnyFutureCourses {
        hasAnyFutureCourses
    }
`;

gql`
    mutation SyncWithCalendarOrder {
        syncWithCalendarOrder
    }
`;

const ExportToGoogleCalendarButton: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
    const { data } = useHasAnyFutureCoursesQuery();
    const hasAnyFutureCourses = data && data.hasAnyFutureCourses;

    const [syncWithGoogleCalendar] = useSyncWithCalendarOrderMutation({
        onCompleted: () => showSnackbar({ snackbarMessage: 'Занятия добавлены в календарь' }),
        onError: (error: ApolloError) => showSnackbar({ snackbarErrors: getErrors(error) }),
    });

    const sync = () => {
        externalLogin('GoogleCalender')
            .then(syncWithGoogleCalendar)
            .catch(() =>
                showSnackbar({ snackbarErrors: [{ message: 'Авторизация через социальные сети не удалась' }] }),
            );
    };

    if (!hasAnyFutureCourses) {
        return null;
    }

    return (
        <div className={classes.wrapper} title="Добавить занятия в Google Календарь">
            <CalendarIcon className={classes.icon} onClick={sync} />
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        wrapper: {
            position: 'absolute',
            top: 10,
            right: 10,
        },
        icon: {
            cursor: 'pointer',
            color: theme.colors.contrastBg,
            width: 20,
            height: 20,

            '&:hover': {
                opacity: 0.8,
            },
        },
    });

export default injectSheet(styles)(ExportToGoogleCalendarButton);
